<template>
  <div class="sub_search_wrap-contents_business">
    <div class="sub_search-contents_titwrap">
      <div class="sub_contents-tit">
        業種
        <span class="ub_contents_close" v-on:click="close()">×</span>
      </div>
    </div>
    <div class="sub_search-contents_business">
      <div class="sub_search-contents_table">
        <table class="m3-table m3-table-search-toggle">
          <tbody>
            <tr>
              <td>
                <div v-for="conditionType in businessTypesStore.master" class="checkbox" :key="conditionType.code" >
                  <input
                    type="checkbox"
                    v-model="businessTypeCodes"
                    :id="`position_type_cds_${conditionType.code}`"
                    :value="conditionType.code"
                    class="css-checkbox">
                  <label :for="`position_type_cds_${conditionType.code}`" class="css-label">&nbsp;{{ conditionType.text }}</label>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="sub_search-fixbtnbox">
      <ul class="sub_search-btn">
        <li><a v-on:click="businessTypesStore.clear()">条件クリア</a></li>
        <li><button type="submit" class="link_btn_green">検索する</button></li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { computed, inject } from 'vue'
import { setupModal } from '@component_path/lib/modal.js'
setupModal('.sub_search-contents_business')

const emit = defineEmits(['close'])

const businessTypesStore = inject('businessTypesStore')
const businessTypeCodes = computed({
  get: () => businessTypesStore.businessTypes.value,
  set: (value) => businessTypesStore.set(value)
})

const close = () => {
  businessTypesStore.reset()
  emit('close')
}
</script>
